var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { AddressModel } from './address';
export class CalculatePricesResponseModel {
    productPlans;
}
export class PurchaseRequestModel {
    companyName;
    companyEmail;
    paymentToken;
    billingAddress;
    shippingAddress;
    billingCycle;
    productPlans;
}
__decorate([
    Type(() => AddressModel),
    __metadata("design:type", AddressModel)
], PurchaseRequestModel.prototype, "billingAddress", void 0);
__decorate([
    Type(() => AddressModel),
    __metadata("design:type", AddressModel)
], PurchaseRequestModel.prototype, "shippingAddress", void 0);
export class UpgradeRequestModel {
    billingCycle;
    productPlans;
}
export class UpdateRequestModel {
    productPlans;
}
export class DowngradeRequestModel {
    billingCycle;
    productPlans;
}
export class CalculateTaxRequestModel {
    shippingAddress;
}
export class CalculateTaxResponseModel {
    taxPercentage;
}
export class CustomRequestModel {
    billingCycle;
    productPlans;
    billingType;
}
//# sourceMappingURL=requests-models.js.map